module.exports = __webpack_public_path__ + "resources/img/img_goldilocks3_m.e0de4b364178f4fa34e05abea9ab0e3d.png";